<template>
  <div class="og-chat-embed">
    <ChatbotWidget
      :api-url="apiUrl"
      :api-token="apiToken"
      layout="sidebar"
      :embedded="true"
      :start-open="true"
    />
  </div>
</template>

<script>
import config from '@/config';
import ChatbotWidget from '@/components/chatbot/ChatbotWidget.vue';

export default {
  name: 'Chat',
  components: {
    ChatbotWidget,
  },
  data() {
    return {
      apiUrl: config.apiUrl || '',
      apiToken: sessionStorage.getItem('@ERP:api_token') || '',
    };
  },
  mounted() {
    document.documentElement.classList.add('og-chat-embed-page');
    document.body.classList.add('og-chat-embed-page');
  },
  beforeDestroy() {
    document.documentElement.classList.remove('og-chat-embed-page');
    document.body.classList.remove('og-chat-embed-page');
  },
};
</script>

<style scoped>
.og-chat-embed {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
</style>

<style>
/* Preenche 100% do iframe - dimensões herdadas do container */
html.og-chat-embed-page,
body.og-chat-embed-page {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
body.og-chat-embed-page #app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
